import React from 'react';
import { styled } from '@mui/material/styles';

const ActiveAbsolute = styled('div', {
  shouldForwardProp: (prop) => prop !== 'height',
})(({ theme, height }) => ({
  position: 'absolute',
  height: 'calc(100% - 130px)',
  width: 'calc(100% - 316px)',
  maxWidth: '100%',
  boxSizing: 'border-box',
  overflow: 'auto',
  padding: theme.spacing(1),

  [theme.breakpoints.down('xl')]: {
    paddingLeft: '0',
    paddingRight: '0',
    width: '100%',
    height: height || window.innerHeight - 194,
  },
  [theme.breakpoints.down('lg')]: {
    position: 'relative',
    height: '100%',
    overflow: undefined,
  },

  '@media print': {
    position: 'relative',
    width: '100%',
    height: 'auto',
    overflow: 'visible',
  },
}));

const Active = styled('div', {
  shouldForwardProp: (prop) => prop !== 'fillRemaining',
})(({ theme, fillRemaining }) => ({
  // Default: flow with content (Document/CourseDocument is the scrollport).
  // fillRemaining: interactive docs — fill under headers; iframe scrolls inside.
  flex: fillRemaining ? '1 1 auto' : '0 0 auto',
  minHeight: fillRemaining ? 0 : undefined,
  width: '100%',
  maxWidth: '100%',
  minWidth: 0,
  height: fillRemaining ? '100%' : 'auto',
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  overflow: fillRemaining ? 'hidden' : 'visible',
  boxSizing: 'border-box',
  padding: theme.spacing(1),
  textAlign: 'center',
  [theme.breakpoints.down('xl')]: {
    paddingLeft: '0',
    paddingRight: '0',
  },
  '@media print': {
    height: 'auto',
    overflow: 'visible',
  },
  '& > div': {
    textAlign: 'initial',
  },
}));

export default function TabContainer(props) {
  const Comp = props.useAbsolute ? ActiveAbsolute : Active;
  return (
    <Comp id="ActiveAbsolute" height={props.height} fillRemaining={props.fillRemaining}>
      {props.children}
    </Comp>
  );
}
